const timeTypes = {
  YEAR: 'Year',
  MONTH: 'Month',
  WEEK: 'Week',
  DAY: 'Day'
}
export default {
  timeTypes,
  timeTypesArr: Object.values(timeTypes)
}
